import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { BlogAuthorInput } from "@/app/Blogs/Components/BlogAuthorInput";
import { generateSlug } from "@/lib/Utils/string";
import { BlogAudienceInput } from "@/app/Blogs/Components/BlogAudienceInput";
import type { BlogPostDetailsInput } from "@/app/Blogs/Validation/blogValidation";

export function BlogPostDetailsForm() {
  const { touched, setFieldValue } = useFormState<BlogPostDetailsInput>();

  return (
    <>
      <TextInput
        autoFocus
        name="title"
        label="Title"
        className="col-span-6"
        onChange={(val) => {
          if (!touched.slug) {
            setFieldValue("slug", val ? generateSlug(val) : "");
          }
        }}
      />
      <TextInput
        name="slug"
        label="Slug"
        className="col-span-6"
        description="Lowercase and dashes only"
      />

      <TextAreaInput
        name="excerpt"
        label="Excerpt"
        className="col-span-8"
        description="Short summary shown in the list view"
      />

      <div className="col-span-4 space-y-6">
        <BlogAuthorInput name="blog_author_id" label="Author" clearable />
        <BlogAudienceInput name="audience" label="Audience" />
      </div>
    </>
  );
}
